import axios from "axios";
import { Apis, BaseUrl } from "../config";
import { toast } from "react-toastify";
import { getProfile, removeProfile } from "./dbactions/profileActions";
import { resetState } from "./dbactions/exploreActions";

export const createUser = (values, history) => async (dispatch) => {
  dispatch({ type: "USER_REQ" });
  try {
    const response = await axios.post(`${BaseUrl}${Apis.signup}`, values);
    dispatch({ type: "SET_USER", payload: response.data });

    if (response.data.userToken.message) {
      toast.error(response.data.userToken.message);
    } else {
      toast.success("Account Created Successfully");
      history.push("/login");
    }
  } catch (error) {
    dispatch({
      type: "USER_FAIL",
      payload: error.response.data,
    });
    toast.error(error.response.message);
  }
};
//Login
export const UserSignin = (values, history) => async (dispatch) => {
  dispatch({ type: "User_req" });
  try {
    const response = await axios.post(`${BaseUrl}${Apis.signin}`, values);
    dispatch({ type: "User_success", payload: response.data });
    if (response.data.accessToken.hasOwnProperty("message")) {
      toast.error(response.data.accessToken.message);
    } else {
      toast.success(
        "Welcome back " + response.data.accessToken.usr[0].user_first_name
      );
      const userData = response.data.accessToken.usr[0];
      const dataUser = response.data.accessToken;
      const email = response.data.accessToken.usr[0].user_email;
      saveSession(dataUser);
      sessionStorage.setItem(
        "profileData",
        JSON.stringify(dataUser?.usr?.at(0))
      );
      dispatch(getProfile(email));
      if (userData && !userData?.user_phone_nbr) {
        history.push("/dashboard/profile/");
      } else if (userData && userData?.role_id <= 4) {
        history.push("/dashboard/mainDashboard/");
      } else {
        history.push("/dashboard/");
      }
    }
  } catch (error) {
    dispatch({
      type: "User_failure",
      payload: error,
    });
  }
};
//Forgotpassword
export const passwordForget = (values, history) => async (dispatch) => {
  dispatch({ type: "Password_req" });
  try {
    const response = await axios.post(`${BaseUrl}${Apis.forgotpass}`, values);
    dispatch({ type: "Password_success", payload: response.data });

    if (response.data.accessToken[0].user_email) {
      toast.success("Reset Password Link Sent Successfully");
      setTimeout(() => {
        history.push("/");
      }, 1000);
    }
  } catch (error) {
    dispatch({
      type: "Password_failure",
      payload: error.response.data,
    });
    toast.error(error.response.data.message);
  }
};

//change password
export const changePassword = (values) => async (dispatch) => {
  dispatch({ type: "change_password_req" });
  const { token } = getSession();
  try {
    const response = await axios.post(
      `${BaseUrl}${Apis.changePasswordapi}`,
      values,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    dispatch({ type: "change_password_success", payload: response.data });
    if (response.data.accessToken.token === "") {
      toast.error(response.data.accessToken.message);
    } else {
      toast.success(response.data.accessToken.message);
    }
  } catch (error) {
    dispatch({
      type: "change_password_failure",
      payload: error.response.data,
    });
    toast.error(error.response.data.message);
  }
};

//session Storage
export const saveSession = (dataUser) => {
  sessionStorage.setItem("token", dataUser.token);
  sessionStorage.setItem("user_profile_id", dataUser.usr[0].user_profile_id);
  sessionStorage.setItem("userFirstname", dataUser.usr[0].user_first_name);
  sessionStorage.setItem("user_last_name", dataUser.usr[0].user_last_name);
  sessionStorage.setItem("role_id", dataUser.usr[0].role_id);
  sessionStorage.setItem("email", dataUser.usr[0].user_email);
  sessionStorage.setItem(
    "user_has_profile_yn",
    dataUser.usr[0].user_has_profile_yn
  );
  sessionStorage.setItem(
    "user_has_bank_acct_yn",
    dataUser.usr[0].user_has_bank_acct_yn
  );
};
export const getSession = () => {
  return {
    token: sessionStorage.getItem("token"),
    user_profile_id: sessionStorage.getItem("user_profile_id"),
    userFirstname: sessionStorage.getItem("userFirstname"),
    user_last_name: sessionStorage.getItem("user_last_name"),
    role_id: sessionStorage.getItem("role_id"),
    email: sessionStorage.getItem("email"),
    user_has_bank_acct_yn: sessionStorage.getItem("user_has_bank_acct_yn"),
    user_has_profile_yn: sessionStorage.getItem("user_has_profile_yn"),
    role:
      sessionStorage.getItem("role_id") === 1
        ? "SU"
        : sessionStorage.getItem("role_id") === "2"
        ? "MAN"
        : sessionStorage.getItem("role_id") === "3"
        ? "SUP"
        : sessionStorage.getItem("role_id") === "4"
        ? "SP"
        : "U",
  };
};
export const clearsession = () => {
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("user_profile_id");
  sessionStorage.removeItem("email");
  sessionStorage.removeItem("role_id");
};
export const logout = () => async (dispatch) => {
  try {
    dispatch({ type: "SignOut" });
    clearsession();
    removeProfile();
    dispatch(resetState());
    window.location.href = "/";
    toast.success("Logout successfully");
    localStorage.removeItem("newPatient");
  } catch (error) {
    toast.error(
      `${
        error.response?.data?.usr?.message ||
        error.response?.data?.message ||
        error.response?.message ||
        error.message
      }`
    );
  }
};
